<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_dashboard'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <BalanceDetails />
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date">
                </div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button></div>
              </div>
              <span v-show="userData.permissions['new_savings'] == 1" class="mt-4"><b-button v-b-modal.new-give-away
                  variant="primary" type="button" class="btn-sm btn"><i class="mdi mdi-plus"></i> New
                  Give Away</b-button></span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">

                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner v-if="data_status == 'Fetching data...'" class="align-middle" type="grow"></b-spinner>
                    <span v-else class="mdi mdi-cancel fs-1"></span>
                    <div class="fw-bold fs-5">{{ data_status }}</div>
                  </div>
                </template>

                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>

                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(reason)="data">
                  <small>{{ data.item.reason || '-' }}</small>
                </template>

                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>

                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                  <small class="d-block text-info fw-bold">{{ data.item.mode_of_payment.name }}</small>
                </template>

                <template #cell(approval)="data">
                  <button v-if="data.item.status == 1" class="btn btn-primary btn-sm"
                    @click.prevent="approve(data.item.id, data.item.member.member_id, data.item.member.name, data.item.amount, data.item.mode_of_payment.name, data.item.date_of_payment)">Approve</button>
                  <button v-else disabled class="btn btn-light btn-sm">Approved</button>
                </template>

                <template #cell(actions)="data">
                  <button class="btn btn-info btn-sm" :disabled="data.item.status == 2"
                    @click.prevent="edit(data.item.id, data.item.member.member_id, data.item.amount, data.item.mode_of_payment.id, data.item.reason, data.item.date_of_payment)">
                    <i class="mdi mdi-square-edit-outline"></i>
                  </button>
                  <button class="btn btn-danger btn-sm" :disabled="data.item.status == 2"
                    @click.prevent="remove(data.item.id, data.item.member.name)">
                    <i class="mdi mdi-trash-can"></i>
                  </button>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col mt-3 fw-bold">Total Amount: <span class="ms-2">{{ commas(TotalAmount)
                  }}/=</span></div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View {{ title }}</span>
            </center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-give-away" centered title="New GiveAway" title-class="font-18" hide-footer>
      <form @submit.prevent="addGiveAway">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select :options="members" placeholder="Select an Option" @input="FindPackage()" v-model="member"
            label="name" :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>GiveAway Amount</label>
          <input v-model="amount" type="number" class="form-control" required />
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reason</label>
          <textarea v-model="reason" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label>
          <input v-model="date_of_payment" :max="currentdate" type="date" class="form-control" required />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-give-away')">Close</b-button>
          <b-button type="submit" :disabled="modal_loader || !member || !mode_of_payment" class="btn ms-1 w-30"
            variant="primary">
            <b-spinner v-if="modal_loader" small></b-spinner>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-give-away" centered title="Edit Give Away" title-class="font-14" hide-footer>
      <form @submit.prevent="editGiveAway">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select disabled :options="members" placeholder="Select an Option" v-model="member" label="name"
            :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>GiveAway Amount</label>
          <input v-model="amount" type="number" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reason</label>
          <textarea v-model="reason" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label>
          <input v-model="date_of_payment" :max="currentdate" type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-give-away')">Close</b-button>
          <b-button :disabled="modal_loader || !member || !mode_of_payment" type="submit" class="btn ms-1 w-30"
            variant="primary">
            <b-spinner v-if="modal_loader" small></b-spinner>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-give-away" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 text-danger mdi mdi-delete-circle"></i></div>
        <p>Are you sure you want to delete give away for</p>
        <p><strong>{{ member }}</strong></p>
        <b-button class="mx-1" variant="danger" @click="confirmDelete">
          <b-spinner v-if="modal_loader" small></b-spinner>
          <span v-else>Yes, Delete</span>
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('delete-give-away')">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="approve" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 text-info mdi mdi-check-circle"></i></div>
        <p>Are you sure you want to approve give away for</p>
        <p><strong>{{ name }}</strong></p>
        <b-button :disabled="modal_loader" class="mx-1" variant="info" @click="confirmApprove">
          <b-spinner v-if="modal_loader" small></b-spinner>
          <span v-else>Yes, Approve</span>
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('approve')">Cancel</b-button>
      </div>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { giveAwayMethods, giveAwayComputed, memberMethods, memberComputed, paymentoptionMethods, paymentoptionComputed } from "@/state/helpers";
import BalanceDetails from "./balanceDetails";

export default {
  page: {
    title: "Give Aways",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    BalanceDetails,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      data_status: 'Fetching data...',
      fetched: false,
      title: "Give Aways",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Give Aways", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "member", label: "To", visible: true },
        { key: "amount", label: "Give Away", visible: true },
        { key: "reason", label: "Reason", visible: true },
        { key: "date_of_payment", label: "Pay Date", visible: true },
        { key: "addedby", label: "Added By", visible: true },
        { key: "approval", label: "Approval", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      member: "",
      name: "",
      amount: "",
      mode_of_payment: "",
      reason: "",
      date_of_payment: "",
      currentdate: new Date().toLocaleDateString("fr-CA"),
      modal_loader: false,
      name_hover: false,
      current_index: 0,

      date_to: new Date().toLocaleDateString("fr-CA"),
      date_from: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...memberComputed,
    ...paymentoptionComputed,
    ...giveAwayComputed,
    List() {
      if (this.fetched) {
        return this.giveaways.length;
      } else {
        return 0;
      }
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      if (this.fetched) {
        return this.giveaways.map((d) => ({ ...d }));
      } else {
        return [];
      }
    },
    IsBusy() {
      let a = false;
      if (this.giveaways.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    TotalAmount() {
      if (this.fetched) {
        return this.giveaways.reduce((a, b) => a + b.amount, 0);
      } else {
        return 0;
      }
    },
  },

  async mounted() {
    await this.fetchGiveAways();
    this.fetched = true;
    this.data_status = 'No Data Found'
    this.TotalRows = this.giveaways.length;
    this.fetchMembers();
    this.fetchPaymentoptions();
  },
  methods: {
    ...giveAwayMethods,
    ...memberMethods,
    ...paymentoptionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

    clearFields() {
      this.id = "";
      this.member = "";
      this.amount = "";
      this.mode_of_payment = "";
      this.reason = "";
      this.date_of_payment = "";
    },

    restore(id, name) {
      this.id = id
      this.name = name
      this.$bvModal.show('restore-applicant')
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    edit(id, member, amount, mode_of_payment, reason, date_of_payment) {
      this.id = id;
      this.member = member;
      this.amount = amount;
      this.mode_of_payment = mode_of_payment;
      this.reason = reason;
      this.date_of_payment = date_of_payment;
      this.$bvModal.show("edit-give-away");
    },

    approve(id, member, name, amount, mode_of_payment, date_of_payment) {
      this.id = id;
      this.member = member;
      this.name = name;
      this.amount = amount;
      this.mode_of_payment = mode_of_payment;
      this.date_of_payment = date_of_payment;
      this.$bvModal.show("approve");
    },

    remove(id, name) {
      this.id = id;
      this.member = name;
      this.$bvModal.show("delete-give-away");
    },

    async addGiveAway() {
      const obj = {
        'member_id': this.member,
        'amount': this.amount,
        'date_of_payment': this.date_of_payment,
        'mode_of_payment': this.mode_of_payment,
        'reason': this.reason
      }
      this.modal_loader = true

      await axios.post('add-give-away', obj).then((response) => {
        if (response.status == 200) {
          this.fetchGiveAways()
          this.$bvModal.hide('new-give-away')
          this.modal_loader = false
          this.$toast.success(`New GiveAway for added!`)
          this.clearFields()
        }
        else {
          this.modal_loader = false
          this.$toast.error('Error occured!')
        }
      })
    },

    async editGiveAway() {
      const obj = {
        'id': this.id,
        'member_id': this.member,
        'amount': this.amount,
        'date_of_payment': this.date_of_payment,
        'mode_of_payment': this.mode_of_payment,
        'reason': this.reason
      }
      this.modal_loader = true

      await axios.post('edit-give-away', obj).then((response) => {
        if (response.status == 200) {
          this.fetchGiveAways()
          this.$bvModal.hide('edit-give-away')
          this.modal_loader = false
          let name = this.members.find(member => member.member_id == this.member).name
          this.$toast.success(`GiveAway for ${name} edited!`)
          this.clearFields()
        }
        else {
          this.modal_loader = false
          this.$toast.error('Error occured!')
        }
      })
    },

    async confirmApprove() {
      this.modal_loader = true
      const obj = {
        'id': this.id,
        'amount': this.amount
      }

      await axios.post('approve-give-away', obj).then((response) => {
        if (response.status == 200) {
          this.fetchGiveAways()
          this.$bvModal.hide('approve')
          this.modal_loader = false
          this.$toast.success(`GiveAway for ${this.name} approved!`)
          this.clearFields()
        }
        else {
          this.modal_loader = false
          this.$toast.error(response.data.error)
        }
      })
    },

    async confirmDelete() {
      this.modal_loader = true
      const obj = {
        'id': this.id,
      }
      await axios.post('delete-give-away', obj).then((response) => {
        if (response.status == 200) {
          this.fetchGiveAways()
          this.$bvModal.hide('delete-give-away')
          this.$toast.success(`GiveAway for ${this.member} deleted!`)
          this.modal_loader = false
          this.clearFields()
        }
        else {
          this.modal_loader = false
          this.$toast.error('Error occured!')
        }
      })
    },

    FilterData() {
      this.filterMembers({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>